namespace $.$$ {

	$mol_style_define( $shm_hitalama_taskmanager_priority, {
		Bubble: {
			boxShadow: '0 0 0 1px ' + $mol_theme.line,
			border: {
				radius: '8px',
			},
			zIndex: 10,
		},

		Trigger: {
			justify: {
				content: 'center'
			},
		},

		Dot: {
			width: '1rem',
			height: '1rem',
			border: {
				radius: '999px',
			},
		},

		Option_dot: {
			width: '.8rem',
			height: '.8rem',
			flex: {
				shrink: 0,
			},
			border: {
				radius: '999px',
			},
		},

		Option_row: {
			alignItems: 'center',
			gap: '8px',
			padding: {
				left: '10px',
				right: '10px',
			},
		},

		Option_label: {
			flex: {
				grow: 1,
				shrink: 1,
			},
		},
	} )

}
